import React, { useState, useEffect } from "react";
import MySubscriptionPlan from "./MySubscriptionPlan";
import ManageSubscription from "./ManageSubscription";
import RegisteredRefferedParents from "./RegisteredRefferedParents";
import {
  userSubscription,
  trialPeriodDataService,
} from "../../../AxiosRtk/Settings";
import { useSelector } from "react-redux";

const MySubscription = ({ getLangTranslation, checkSubsciption }) => {
  const [activeTab, setActiveTab] = useState(0);
  // const [subscription, setSubscription] = useState(null);
  // const [trialPeriodData, setTrialPeriodData] = useState(null);

  const { subscription, trialPeriod } = useSelector(({ settings }) => settings);


  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 0:
        return (
          <MySubscriptionPlan
            subscription={subscription}
            trialPeriodData={trialPeriod}
            getLangTranslation={getLangTranslation}
          />
        );
      case 1:
        return (
          <ManageSubscription
            getLangTranslation={getLangTranslation}
            subscriptionData={subscription}
          />
        );
      case 2:
        return (
          <RegisteredRefferedParents getLangTranslation={getLangTranslation} />
        );
      default:
        return null;
    }
  };

  return (
    <>
      <ul className="custom-tab-wrap">
        <li
          className={`custom-tab ${activeTab === 0 ? "active-tab" : ""}`}
          onClick={() => handleTabClick(0)}
        >
          {getLangTranslation("MY_SUBSCRIPTION_PLAN", "My Subscription Plan")}
        </li>
        <li
          className={`custom-tab ${activeTab === 1 ? "active-tab" : ""}`}
          onClick={() => handleTabClick(1)}
        >
          {getLangTranslation(
            "MANAGE_SUBSCRIPTION_TITLE",
            "Manage subscripiton"
          )}
        </li>
        <li
          className={`custom-tab ${activeTab === 2 ? "active-tab" : ""}`}
          onClick={() => handleTabClick(2)}
        >
          {getLangTranslation(
            "SETTING_REGISTERED_REFERRED_PARENTS",
            "Registered referred parents"
          )}
        </li>
      </ul>
      {renderTabContent()}
    </>
  );
};

export default MySubscription;
